export const UPDATE_MAP_LOADER = 'UPDATE_MAP_LOADER'
export const UPDATE_COORDINATES_DATA = 'UPDATE_COORDINATES_DATA'
export const UPDATE_LOCATION_MODAL = 'UPDATE_LOCATION_MODAL'
export const UPDATE_SELECTED_POSTCODE = 'UPDATE_SELECTED_POSTCODE'
export const UPDATE_LOCATION_FOCUS = 'UPDATE_LOCATION_FOCUS'
